import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const Referral00Table: GenericTableSchemaInterface = {
  id: "referral-00",
  name: "Referral 00",
  description: "This table contains data regarding referrals.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName,
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId,
    },
    c03: {
      name: "Referred By Name",
      variable: VarKey.UserReferredByName,
    },
    c04: {
      name: "Referred By User ID",
      variable: VarKey.UserReferredBy,
    },
    c05: {
      name: "Referral Complete",
    },
    c06: {
      name: "Second Check Complete",
    },
  },
};
